import React from 'react';

const ExplorePage = () => {
  return (
    <div className="min-h-screen bg-gray-50 flex items-center justify-center">
      <div className="text-center">
        <h1 className="text-3xl font-bold text-gray-900 mb-4">
          Explore Page
        </h1>
        <p className="text-gray-600">
          Discover new fashion items and collections
        </p>
      </div>
    </div>
  );
};

export default ExplorePage;